var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
import { AllShapes } from '@clr/icons/shapes/all-shapes';
import React from 'react';
import { HAS, INVERSE, IS, SOLID } from '../../constants';
import classes from '../../utils/classes';
import cssPrefix from '../../utils/cssPrefix';
import withMemoRef from '../../utils/withMemoRef';
/**
 * Icon is prefix.
 */
const isPrefix = cssPrefix(IS);
/**
 * Icon has prefix.
 */
const hasPrefix = cssPrefix(HAS);
/**
 * List of possible shapes.
 */
const shapes = Object.keys(AllShapes);
/**
 * Default shape to be loaded if the given one is missing in the shapes array.
 */
const DEFAULT_SHAPE = 'exclamation-circle';
/**
 * Icon component (clr-icon wrapper).
 *
 * @param props Icon properties.
 */
export const Icon = withMemoRef('Icon', (_a, ref) => {
  var {
      className,
      direction,
      has,
      is,
      inverse,
      role = 'none',
      shape = DEFAULT_SHAPE,
      solid
    } = _a,
    props = __rest(_a, [
      'className',
      'direction',
      'has',
      'is',
      'inverse',
      'role',
      'shape',
      'solid'
    ]);
  return React.createElement(
    'clr-icon',
    Object.assign(
      {
        class: classes(
          {
            [hasPrefix(has)]: has,
            [isPrefix(INVERSE)]: inverse,
            [isPrefix(SOLID)]: solid,
            [isPrefix(is)]: is
          },
          className
        ),
        dir: direction,
        role: role,
        shape: shapes.includes(shape.split(' ')[0]) ? shape : DEFAULT_SHAPE
      },
      Object.assign(Object.assign({}, props), { ref })
    )
  );
});
export default Icon;
